import { render } from "./AdvertisingLeft.vue?vue&type=template&id=f2aa2978&scoped=true"
import script from "./AdvertisingLeft.vue?vue&type=script&lang=js"
export * from "./AdvertisingLeft.vue?vue&type=script&lang=js"

import "./AdvertisingLeft.vue?vue&type=style&index=0&id=f2aa2978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2aa2978"]])

export default __exports__